import { render, staticRenderFns } from "./ClientsBillsTable.vue?vue&type=template&id=04bba86e&scoped=true&"
import script from "./ClientsBillsTable.vue?vue&type=script&lang=js&"
export * from "./ClientsBillsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bba86e",
  null
  
)

export default component.exports